<div class="accordion">
  <div class="accordion-header" (click)="visible = !visible">
    <span [translationEditableDirective]="title" class="is-unselectable">{{
      title | translate
    }}</span>
    <button class="accordion-arrow">
      <i
        class="fa-solid"
        [ngClass]="{ 'fa-chevron-down': !visible, 'fa-chevron-up': visible }"
      ></i>
    </button>
  </div>
  <div class="accordion-body" *ngIf="visible">
    <ng-content></ng-content>
  </div>
</div>
